import { render, staticRenderFns } from "./PayDashboardHeader.vue?vue&type=template&id=747e2442&"
import script from "./PayDashboardHeader.vue?vue&type=script&lang=js&"
export * from "./PayDashboardHeader.vue?vue&type=script&lang=js&"
import style0 from "./PayDashboardHeader.vue?vue&type=style&index=0&id=747e2442&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports